import React, { CSSProperties, FC, ReactNode, useState } from 'react'
import { Button, ButtonProps, ConfigProvider, Drawer, DrawerProps } from 'antd'
import { CloseOutlined } from '@ant-design/icons'

interface CustomDrawerProps {
  representativeButton: ReactNode
  representativeButtonSize?: ButtonProps['size']
  header: ReactNode
  placement: DrawerProps['placement']
  footer?: ReactNode
  children: ReactNode
}

export const CustomDrawer: FC<CustomDrawerProps> = ({ representativeButton, representativeButtonSize, header, placement, footer, children }) => {
  const [open, setOpen] = useState(false)
  const showDrawer = () => {
    setOpen(true)
  }
  const onClose = () => {
    setOpen(false)
  }

  const drawerStyles: { [key: string]: CSSProperties } = {
    body: {
      padding: '12px',
    },
    mask: {
      height: '100vh',
    },
    header: {
      borderColor: '#F1F5F7FF',
      padding: '15px 12px',
    },
  }

  return (
    <>
      <Button size={representativeButtonSize ?? 'large'} onClick={showDrawer}>
        {representativeButton}
      </Button>

      <ConfigProvider
        drawer={{
          styles: drawerStyles,
        }}
      >
        <Drawer
          title={
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              {header}
              <Button size={'small'} type="text" onClick={onClose}>
                <CloseOutlined />
              </Button>
            </div>
          }
          placement={placement}
          open={open}
          closable={false}
          onClose={onClose}
          footer={footer}
        >
          {children}
        </Drawer>
      </ConfigProvider>
    </>
  )
}
